import { AddAddressDataInput, AddAddressDataResponse, AgentByIdResponse, CancelHandshakeInput, CancelHandshakeResponse, FindAgentInput, FindAgentResponse, GetAgentByIdResponse, GetAgentListResponse, GetContactByIdResponse, LoadAgentContactsInput, LoadAgentContactsResponse, RemoveAddressDataInput, RemoveAddressDataResponse, UpdateAddressDataInput, UpdateAddressDataResponse } from 'services/interface'

import { addAddressData, cancelHandshake, findAgentData, getAgentById, getAgentsList, getContactById, loadAgentContacts, removeAddressData, updateAddressData } from 'services/agentsApi'
import { UseMutationResult, useMutation, UseQueryResult, useQuery } from '@tanstack/react-query'
export const useFindAgentData = (): UseMutationResult<
  FindAgentResponse,
  Error,
  FindAgentInput,
  unknown
> => {
  return useMutation<FindAgentResponse, Error, FindAgentInput, unknown>({
    mutationFn: (input: FindAgentInput): Promise<FindAgentResponse> => findAgentData(input),
    onSuccess: () => {
      // Handle success
    },
  })
}

export const useGetAgentsList = (): UseQueryResult<GetAgentListResponse, Error> => {
  return useQuery<GetAgentListResponse, Error>({
    queryKey: ['agentsList'],
    queryFn: () => getAgentsList(),
    // staleTime: 1000 * 60 * 60 * 24,  
  })
}

export const useLoadContactsList = (
  input: LoadAgentContactsInput
): UseQueryResult<LoadAgentContactsResponse, Error> => {
  return useQuery<LoadAgentContactsResponse, Error>({
    queryKey: [
      'load_contacts',
      input.ref_type,
      input.limit,
      input.offset,
      input.search,
      input.sort_by,
    ],
    queryFn: () => loadAgentContacts(input),
    // staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetContactById = (
  agentId: string
): UseQueryResult<GetContactByIdResponse, Error> => {
  return useQuery<GetContactByIdResponse, Error>({
    queryKey: ['contact', agentId],
    queryFn: () => getContactById(agentId),
    // staleTime: 1000 * 60 * 60 * 1,
  })
}

export const useGetAgentById = (
  agentId: string
): UseQueryResult<GetAgentByIdResponse, Error> => {
  return useQuery<GetAgentByIdResponse, Error>({
    queryKey: ['agents', agentId],
    queryFn: () => getAgentById(agentId),
    // staleTime: 1000 * 60 * 60 * 1,
  })
}

export const useGetAgentDataById = (): UseMutationResult<
  GetAgentByIdResponse,
  Error,
  string,
  unknown
> => {
  return useMutation<GetAgentByIdResponse, Error, string, unknown>({
    mutationFn: (input: string): Promise<GetAgentByIdResponse> => getAgentById(input),
    onSuccess: () => {
      // Handle success
    },
  })
}

export const useCancelHandshake = (): UseMutationResult<
  CancelHandshakeResponse,
  Error,
  CancelHandshakeInput,
  unknown
> => {
  return useMutation<CancelHandshakeResponse, Error, CancelHandshakeInput, unknown>({
    mutationFn: (input: CancelHandshakeInput): Promise<CancelHandshakeResponse> => cancelHandshake(input),
    onSuccess: () => {
      // Handle success
    },
  })
}

export const useAddAddressData = (): UseMutationResult<
  AddAddressDataResponse,
  Error,
  AddAddressDataInput,
  unknown
> => {
  return useMutation<AddAddressDataResponse, Error, AddAddressDataInput, unknown>({
    mutationFn: (input: AddAddressDataInput): Promise<AddAddressDataResponse> => addAddressData(input),
    onSuccess: () => {
      // Handle success
    },
  })
}

export const useUpdateAddressData = (): UseMutationResult<
  UpdateAddressDataResponse,
  Error,
  UpdateAddressDataInput,
  unknown
> => {
  return useMutation<UpdateAddressDataResponse, Error, UpdateAddressDataInput, unknown>({
    mutationFn: (input: UpdateAddressDataInput): Promise<UpdateAddressDataResponse> => updateAddressData(input),
    onSuccess: () => {
      // Handle success
    },
  })
}

export const useRemoveAddressData = (): UseMutationResult<
  RemoveAddressDataResponse,
  Error,
  RemoveAddressDataInput,
  unknown
> => {
  return useMutation<RemoveAddressDataResponse, Error, RemoveAddressDataInput, unknown>({
    mutationFn: (input: RemoveAddressDataInput): Promise<RemoveAddressDataResponse> => removeAddressData(input),
    onSuccess: () => {
      // Handle success
    },
  })
}
